/** Shared constants used across all packages. */

export const DEFAULT_EVENT_COLOR = '#6366f1';
export const DEFAULT_NOTE_COLOR = '#f59e0b';

/** Priority levels for tasks. */
export const PRIORITY_LOW = 0;
export const PRIORITY_MEDIUM = 1;
export const PRIORITY_HIGH = 2;

/** WebSocket reconnection parameters. */
export const RECONNECT_BASE_MS = 1000;
export const RECONNECT_MAX_MS = 30_000;
export const HEARTBEAT_INTERVAL_MS = 30_000;

/** JWT configuration. */
export const JWT_EXPIRY_SECONDS = 24 * 60 * 60; // 24 hours
export const REFRESH_TOKEN_TTL_SECONDS = 7 * 24 * 60 * 60; // 7 days

/** bcrypt rounds. */
export const BCRYPT_ROUNDS = 12;

/** Development origins for CORS. */
export const WORKER_DEV_PORT = 3100;
export const DESKTOP_DEV_PORT = 3101;
export const PWA_DEV_PORT = 3102;
